import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card bg-primary-bg border-primary-yellow mx-3 mt-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-body p-2" }, "\n        勤怠変更申請が却下されました。至急内容をご確認のうえ再申請してください\n      ", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ApplicationCard = _resolveComponent("ApplicationCard")!
  const _component_ApplicationsEvaluation = _resolveComponent("ApplicationsEvaluation")!
  const _component_ApplicationsMenu = _resolveComponent("ApplicationsMenu")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, { ref: "header" }, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(),
        (_ctx.application)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.getFormattedWorkTimeRange), 1)
            ], 64))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    }, 512),
    _createTextVNode(),
    (
        _ctx.application &&
          _ctx.application.order &&
          _ctx.application.attendanceCorrection &&
          _ctx.application.attendanceCorrection.status === 'rejected'
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.application)
      ? (_openBlock(), _createBlock(_component_ApplicationCard, {
          key: 1,
          application: _ctx.application,
          class: "mt-3 mx-3 mb-2"
        }, null, 8, ["application"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.application && _ctx.evaluation)
      ? (_openBlock(), _createBlock(_component_ApplicationsEvaluation, {
          key: 2,
          officeName: _ctx.application.order.office.name,
          evaluation: _ctx.evaluation
        }, null, 8, ["officeName", "evaluation"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.application)
      ? (_openBlock(), _createBlock(_component_ApplicationsMenu, {
          key: 3,
          application: _ctx.application,
          favoriteOffice: _ctx.favoriteOffice,
          isSentMessage: _ctx.isSentMessage,
          onAddFavoriteOffice: _ctx.addFavoriteOffice
        }, null, 8, ["application", "favoriteOffice", "isSentMessage", "onAddFavoriteOffice"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createVNode(_component_AppFooter)
  ]))
}